<template>
  <b-modal

    id="educational-video-modal"
    :title="$t('Educational video')"
    no-close-on-backdrop
    size="lg"
    hide-footer
  >
    <video
      width="100%"
      controls
    >
      <source
        :src="`/storage/videos/${appConfig.educational_video_path}`"
        type="video/mp4"
      >
    </video>
  </b-modal>
</template>

<script>
import {
  BModal,
} from 'bootstrap-vue'
import store from '@/store'

export default {
  name: 'EducationalVideoModal',
  components: { BModal },
  computed: {
    appConfig() {
      return store.state.app.appConfig
    },
  },
}
</script>

<style scoped>

</style>
